export class Sugestao {
    sugestaoid: number;
    areaparticipacaoid: number;
    participanteid: number;
    enqueteid: number;
    descricao: string;
}